import Utils from '../../util';

export interface UserPreferencesInterface {
  openProjListDisplayCount: number|string;
  openProjListSortOrder: string;
}

export class UserPreferences {
  /**
   * The display count in the frontend model can be either
   * a number or string. There is an option for 'all' to be selected
   * as well as different number options.
   */
  openProjListDisplayCount: number|string;
  openProjListSortOrder: string;

  constructor(params: UserPreferencesInterface = {
    openProjListDisplayCount: DefaultUserPreference.OPEN_PROJECT_NUM_OF_PROJ,
    openProjListSortOrder: DefaultUserPreference.OPEN_PROJECT_SORT_OPTION
  }) {
    /**
     * Cast numeric values to number type, else can be a string.
     */
    if (Utils.isNumeric(params.openProjListDisplayCount)) {
      this.openProjListDisplayCount = Number(params.openProjListDisplayCount);
    } else {
      this.openProjListDisplayCount = params.openProjListDisplayCount
        ?? DefaultUserPreference.OPEN_PROJECT_NUM_OF_PROJ;
    }
    this.openProjListSortOrder = params.openProjListSortOrder
      ?? DefaultUserPreference.OPEN_PROJECT_SORT_OPTION;
  }

  /**
   * Creates a separate copy of the provided user preferences class
   * @param userPreferences is a UserPreference object
   */
  static deepCopy(userPreferences: UserPreferences): UserPreferences {
    let copy: UserPreferences;
    if (userPreferences) {
      copy = new UserPreferences(userPreferences);
      return copy;
    }
    throw new Error('user preferences deep copy failed');
  }
}

export enum UserPreferenceProps {
  OPEN_PROJ_LIST_DISPLAY_COUNT = 'openProjListDisplayCount',
  OPEN_PROJ_LIST_SORT_ORDER = 'openProjListSortOrder'
}

export enum DefaultUserPreference {
  OPEN_PROJECT_SORT_OPTION = 'dateLastTouched',
  OPEN_PROJECT_NUM_OF_PROJ = '5'
}
